/*
============================================================
R. REBELLION TIMES CART ADD ON
Custom JavaScript added September 2026

Controls quantity and ADD behavior for the complimentary
Pendleton Round Up Edition in the Reformation cart drawer.

Loaded globally from theme.liquid.

TO REMOVE LATER:
Remove the script include from theme.liquid
and delete this asset.
============================================================
*/


document.addEventListener('click', async function(event) {


  /*
  ============================================================
  QUANTITY MINUS
  ============================================================
  */

  const minusButton = event.target.closest('.rr-roundup-minus');

  if (minusButton) {

    event.preventDefault();

    const addon = minusButton.closest('[data-roundup-addon]');

    if (!addon) return;

    const qtyInput = addon.querySelector('.rr-roundup-qty');

    if (!qtyInput) return;

    const min = parseInt(qtyInput.min, 10) || 1;

    const current = parseInt(qtyInput.value, 10) || 1;

    qtyInput.value = Math.max(min, current - 1);

    return;

  }



  /*
  ============================================================
  QUANTITY PLUS
  ============================================================
  */

  const plusButton = event.target.closest('.rr-roundup-plus');

  if (plusButton) {

    event.preventDefault();

    const addon = plusButton.closest('[data-roundup-addon]');

    if (!addon) return;

    const qtyInput = addon.querySelector('.rr-roundup-qty');

    if (!qtyInput) return;

    const current = parseInt(qtyInput.value, 10) || 1;

    const max = parseInt(qtyInput.max, 10);


    if (!max || current < max) {

      qtyInput.value = current + 1;

    }

    return;

  }



  /*
  ============================================================
  ADD NEWSPAPER TO CART
  ============================================================
  */

  const addButton = event.target.closest('.rr-roundup-add');

  if (!addButton) return;

  event.preventDefault();


  const addon = addButton.closest('[data-roundup-addon]');

  if (!addon) return;


  const qtyInput = addon.querySelector('.rr-roundup-qty');

  const message = addon.querySelector(
    '.rr-roundup-addon__message'
  );


  if (!qtyInput) return;


  const variantId = parseInt(
    addButton.dataset.variantId,
    10
  );


  let quantity = parseInt(
    qtyInput.value,
    10
  ) || 1;


  quantity = Math.max(1, quantity);


  const max = parseInt(
    qtyInput.max,
    10
  );


  /*
  ============================================================
  RESPECT AVAILABLE INVENTORY
  ============================================================
  */

  if (max && quantity > max) {

    quantity = max;

    qtyInput.value = max;

  }



  /*
  ============================================================
  MAKE SURE VARIANT ID EXISTS
  ============================================================
  */

  if (!variantId) {

    if (message) {

      message.textContent =
        'Unable to add newspaper.';

    }

    return;

  }



  /*
  ============================================================
  ADDING STATE
  ============================================================
  */

  addButton.disabled = true;

  addButton.textContent = 'ADDING';


  if (message) {

    message.textContent = '';

  }



  /*
  ============================================================
  SEND TO SHOPIFY CART
  ============================================================
  */

  try {

    const response = await fetch(
      window.Shopify.routes.root + 'cart/add.js',
      {

        method: 'POST',

        headers: {

          'Content-Type': 'application/json',

          'Accept': 'application/json'

        },

        body: JSON.stringify({

          items: [

            {

              id: variantId,

              quantity: quantity

            }

          ]

        })

      }
    );


    const data = await response.json();



    /*
    ============================================================
    HANDLE SHOPIFY ERROR
    ============================================================
    */

    if (!response.ok) {

      throw new Error(

        data.description ||

        data.message ||

        'Unable to add newspaper.'

      );

    }



    /*
    ============================================================
    SUCCESS

    Newspaper is now actually in the Shopify cart.

    We intentionally DO NOT reload the page.
    This keeps the Reformation cart drawer open.
    ============================================================
    */

    addButton.textContent = 'ADDED ✓';



    if (message) {

      message.textContent =

        quantity === 1

          ? 'Added to your cart.'

          : quantity + ' copies added to your cart.';

    }



    /*
    ============================================================
    REPLACE OFFER WITH CONFIRMATION

    Gives the customer visual confirmation while keeping
    the cart drawer open.
    ============================================================
    */

    setTimeout(function() {

      addon.classList.add(
        'rr-roundup-added'
      );


      addon.innerHTML = `

        <div class="rr-roundup-added__message">

          <span class="rr-roundup-added__check">
            ✓
          </span>

          <div class="rr-roundup-added__text">

            <strong>
              Added to your cart
            </strong>

            <span>
              ${
                quantity === 1
                  ? 'Your Round Up Edition is coming with you.'
                  : quantity + ' Round Up Editions are coming with you.'
              }
            </span>

          </div>

        </div>

      `;

    }, 450);



  } catch (error) {


    /*
    ============================================================
    ERROR STATE
    ============================================================
    */

    addButton.disabled = false;

    addButton.textContent = 'ADD';


    if (message) {

      message.textContent =
        error.message;

    }


  }


});